import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { push } from 'connected-react-router';

import * as api from './api';
import * as constants from './constants';
import * as types from './types';


export const jumpToTime = createAction(types.JUMP_TO_TIME);
export const updateColumnsRatio = createAction(types.UPDATE_COLUMNS_RATIO);
export const videoPlayerMounted = createAction(types.VIDEO_PLAYER_MOUNTED);
export const updateCommandsFilter = createAction(types.UPDATE_COMMANDS_FILTER);
export const appendNotification = createAction(types.APPEND_NOTIFICATION);
export const setGalleryFullScreen = createAction(types.SET_GALLERY_FULL_SCREEN);
export const cleanup = createAction(types.CLEANUP);

export const reportJobIssue = createApiAction(
  types.REPORT_JOB_ISSUE,
  (payload) => api.reportJobIssue(payload),
);


export const updateJobPath = ({ id, path }) => (
  push(`/tests/${id}/${path}`)
);

export const openReportJobIssueModal = () => (dispatch) => (
  dispatch(modalActions.showModal(constants.REPORT_JOB_ISSUE_MODAL))
);

export const recordTrackViewed = (baseConfig, { id, error }) => (dispatch) => {
  if (baseConfig) {
    dispatch(recordTrack('Automated Test viewed', { id, error }));
  } else {
    dispatch(recordTrack('Live Test viewed', { id, error }));
  }
};
